import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

// HOC para compatibilidade com withRouter do React Router v5
export function withRouter(Component) {
    function ComponentWithRouterProp(props) {
        let location = useLocation();
        let navigate = useNavigate();
        let params = useParams();
        
        // Criando um objeto history compatível com v5
        const history = {
            push: navigate,
            replace: (path) => navigate(path, { replace: true }),
            go: (n) => navigate(n),
            goBack: () => navigate(-1),
            goForward: () => navigate(1),
            location: location
        };

        return (
            <Component
                {...props}
                history={history}
                location={location}
                match={{ params }}
            />
        );
    }

    return ComponentWithRouterProp;
}